import React, { useState } from 'react';
import { Block, FlexRow, imageNotFound } from '@guryou/html-components';

const MyImagePreview = ({ src, alt = 'image', videos, active }) => {
  const [imageSrc, setImageSrc] = useState(src);

  const handleError = () => {
    setImageSrc(imageNotFound); // Set to default image if the original fails
  };

  return (
    <>
      <FlexRow justifyContent="center" alignItems="center">
        <img src={imageSrc} style={{ maxHeight: '500px' }} alt={alt} onError={handleError} />
      </FlexRow>
      <FlexRow xs={12}>
        {videos.map(x => (
          <Block xs={12} margin={1} padding={4} color="white" border="1px solid lightgray" background={x.id === active ? '#414a4c' : 'inherit'}>
            {x.title}
          </Block>
        ))}
      </FlexRow>
    </>
  );
};

export default MyImagePreview;
